import { get } from 'svelte/store';
import { authToken } from '../store.svelte';

const BASE = '/api';

async function request<T>(path: string, options: RequestInit = {}): Promise<T> {
    const token = get(authToken);
    const res = await fetch(`${BASE}${path}`, {
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
            ...(options.headers ?? {}),
        },
    });
    if (!res.ok) {
        let detail = '';
        try { detail = (await res.json()).detail ?? ''; } catch {}
        const err: any = new Error(detail || `API error ${res.status}: ${path}`);
        err.status = res.status;
        throw err;
    }
    return res.json();
}

export const api = {
    get: <T>(path: string) => request<T>(path),
    post: <T>(path: string, body: unknown) =>
        request<T>(path, { method: 'POST', body: JSON.stringify(body) }),
};
